var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('h6',{staticClass:"tw-text-xl tw-m-30"},[_vm._v(" "+_vm._s(_vm.question)),(_vm.required)?_c('b',[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }